<div class="text-white">
  @if (collapseTrigger) {
    <bv-dialog-title>{{ "LOGIN" | translate }}</bv-dialog-title>
  }
  @if (topTrigger) {
    <bv-dialog-title>{{ "CONNECT_EMAIL" | translate }}</bv-dialog-title>
  }
  <bv-dialog-body>
    <div
      class="flex flex-col justify-around items-center"
      [@tdCollapse]="{ value: topTrigger, params: { duration: 200 } }"
      [style.overflow]="'hidden'"
      >
      <div>
        <button
          id="btn_login_connect_facebook"
          data-testid="login-facebook-btn"
          bv-button variant="primary"
          (click)="socialLogin('facebook')"
          class="mat-button-lg facebook-blue"
          >
          {{ "CONNECT_FACEBOOK" | translate }}
        </button>
      </div>
      <div>
        <button
          id="btn_login_connect_google"
          data-testid="login-google-btn"
          bv-button variant="primary"
          (click)="socialLogin('google')"
          class="mat-button-lg google-red"
          >
          {{ "CONNECT_GOOGLE" | translate }}
        </button>
      </div>
      <div>
        <button
          id="btn_login_connect_email"
          data-testid="login-connect-email-btn"
          bv-button variant="primary"
          (click)="toggleCollapse()"
          class="mat-button-lg"
          >
          {{ "CONNECT_EMAIL" | translate }}
        </button>
      </div>
    </div>
    <div
      [@tdCollapse]="{ value: collapseTrigger, params: { duration: 200 } }"
      [style.overflow]="'hidden'"
      >
      <div>
        <bv-form-field label="{{ 'EMAIL' | translate }}">
          <input
            id="input_modal_login_email"
            data-testid="login-email-input"
            bv-input
            [(ngModel)]="loginEmail"
            type="email"
            (keyup.enter)="loginEmailPassword()"
            />
        </bv-form-field>
        <bv-form-field label="{{ 'PASSWORD' | translate }}">
          <input
            id="input_modal_login_password"
            data-testid="login-password-input"
            bv-input
            [(ngModel)]="loginPassword"
            type="password"
            (keyup.enter)="loginEmailPassword()"
            />
        </bv-form-field>
      </div>
    </div>
  </bv-dialog-body>
  @if (topTrigger) {
    <bv-dialog-footer>
      <button
        id="btn_login_reset_password"
        bv-button variant="ghost"
        (click)="resetPassword()"
        >
        {{ "RESET_PASSWORD" | translate }}
      </button>
      <button id="btn_login_previous" bv-button variant="ghost" (click)="toggleCollapse()">
        {{ "PREVIOUS" | translate }}
      </button>
      <button
        id="btn_login_login_email_password"
        data-testid="login-submit-btn"
        bv-button variant="primary" [disabled]="!loginEmail || !loginPassword"
        (click)="loginEmailPassword()"
        >
        {{ "LOGIN" | translate }}
      </button>
    </bv-dialog-footer>
  }
</div>
